import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import persist from '@alpinejs/persist';
import anchor from '@alpinejs/anchor';

import { gsap } from 'gsap';
import { SplitText } from 'gsap/SplitText';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin';

import Lenis from 'lenis';
import htmx from 'htmx.org';

import Swiper from 'swiper';
import { Autoplay, EffectFade, Navigation, Pagination, EffectCoverflow } from 'swiper/modules';

import { paragraphModule } from './paragraph';
import { linkModule } from './link';
import { eyebrowModule } from './eyebrow';
import { introModule } from './intro';
import { statisticModule } from './statistic';

// CSS
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/pagination';
import 'swiper/css/effect-coverflow';

Swiper.use([Autoplay, EffectFade, Navigation, Pagination, EffectCoverflow]);
gsap.registerPlugin(SplitText, ScrollTrigger, ScrollToPlugin, DrawSVGPlugin);

Alpine.plugin(persist);
Alpine.plugin(collapse);
Alpine.plugin(anchor);

// Components
paragraphModule();
linkModule();
eyebrowModule();
introModule();
statisticModule();

// Global
window.Alpine = Alpine;
window.Swiper = Swiper;
window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;
window.DrawSVGPlugin = DrawSVGPlugin;
window.SplitText = SplitText;
window.htmx = htmx;

// Inits
Alpine.start();

const lenis = new Lenis({
    autoRaf: true,
    duration: 0.5,
    anchors: true,
    prevent: (node) => node.classList?.contains('js-modal')
});

lenis.on('scroll', ScrollTrigger.update);